
(function () {
  const accordianItems = document.querySelectorAll('.footer-block--menu');

  accordianItems.forEach((item) => {
    const accordianButton = item.querySelector('.footer-block__heading');
    accordianButton.addEventListener('click', () => {
      item.classList.toggle('active');
    });
  })
})();